import { useGetFinancialData } from "@features/ax/dashboard/hooks";
import { logEvent } from "@shared/analytics/analytics";
import { useRemoteUtilityId } from "@shared/selectors/globalSelectors";
import { useEffect } from "react";
import { AssetManagementSection } from "./assetSection";
import { ExpenditureSection } from "./expenditure";
import { FinancialOverviewSection } from "./financialOverview";

const Financial = () => {
  const remoteUtilityId = useRemoteUtilityId();
  const { data: financialData } = useGetFinancialData({
    remote_utility_id: remoteUtilityId,
    date_filter: "monthly",
  });
  useEffect(() => {
    logEvent("Financial Dashboard Viewed", {});
  }, []);
  return (
    <div className="space-y-6">
      <FinancialOverviewSection data={financialData} />
      <ExpenditureSection data={financialData} />
      <AssetManagementSection data={financialData} />
    </div>
  );
};

export default Financial;
